import React from 'react';

import Select from '@material-ui/core/Select';

interface SelectTimeCommonProps { 
  handleChange: (event: any) => void;
  selectTime: string;
  work: any;
};

const selectTimeCommon = (props: SelectTimeCommonProps) => {

  let work = Object.keys(props.work);
  let timeWork: Array<number> = [];

  if(work.length>0) {
  
  const startWork: number = +work[0]
  const endWork: number = +work[work.length-1];

  const range: Function = (start: number, stop: number, step: number = 0.5): Array<number> => Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step);
    timeWork = range(startWork, endWork + 1);
  }

  const timeOptions: Array<JSX.Element> = timeWork.map((item: number, index: number) => {

    const intItem: number = Math.floor(item);
    const dis: boolean = !props.work.hasOwnProperty(intItem);

    let time: string = item.toFixed(2).toString().replace('.5','.3');

    if (time.length === 4) {
      time = '0'+ time;
    };

    return <option key={ index } value={ time } disabled={ dis }>{ time.replace('.', ':') }</option>;
  });
    
  return (
    <span>
      <Select native
        onChange={ props.handleChange }
        value={ props.selectTime }
        inputProps={{
          name: 'time',
          id: 'time'
        }}
      >
        <option value='' ></option>;
        { timeOptions }
      </Select>
    </span>
  )
};

export default selectTimeCommon;
